import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import ReactMarkdown from 'react-markdown';

const ResponseDisplay = ({ response }) => {
  return (
    <Paper 
      elevation={2} 
      sx={{ 
        mt: 4, 
        borderRadius: 2,
        backgroundColor: 'white',
        overflow: 'hidden'
      }}
    >
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom color="primary">
          Answer
        </Typography>
        <Box 
          sx={{ 
            backgroundColor: '#f9f9f9', 
            p: 2, 
            borderRadius: 1,
            fontSize: '16px',
            lineHeight: 1.6
          }}
        >
          <ReactMarkdown>{response.response}</ReactMarkdown>
        </Box>
      </Box>

      {/* Source data accordion section commented out
      {response.contexts && response.contexts.length > 0 && (
        <>
          <Divider />
          <Accordion 
            expanded={expanded} 
            onChange={handleAccordionChange}
            disableGutters
            elevation={0}
            sx={{ backgroundColor: '#f5f5f5' }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle1">
                View Source Data ({response.contexts.length})
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              {response.contexts.map((context, index) => (
                <Box 
                  key={index} 
                  sx={{ 
                    mb: 2, 
                    p: 2, 
                    backgroundColor: 'white',
                    borderRadius: 1,
                    border: '1px solid #e0e0e0',
                    fontSize: '14px'
                  }}
                >
                  <Typography variant="subtitle2" gutterBottom>
                    Source {index + 1}: {context.partner} / {context.provider}
                  </Typography>
                  <Typography variant="caption" display="block" gutterBottom color="text.secondary">
                    Created: {new Date(context.created_at).toLocaleString()}
                  </Typography>
                  <Box sx={{ mt: 1, whiteSpace: 'pre-wrap' }}>
                    {context.text}
                  </Box>
                </Box>
              ))}
            </AccordionDetails>
          </Accordion>
        </>
      )}
      */}
    </Paper>
  );
};

export default ResponseDisplay;
